import { render } from "./OrderJobsComponent.vue?vue&type=template&id=229402aa&ts=true"
import script from "./OrderJobsComponent.vue?vue&type=script&lang=ts"
export * from "./OrderJobsComponent.vue?vue&type=script&lang=ts"

import "./OrderJobsComponent.vue?vue&type=style&index=0&id=229402aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__